// North crossing: hotel, flats, bar row and hotel tower. Existing collision remains authoritative.
import type {HdBuilding} from '../../common/src/data';
import type {LightFn} from './hd-registry';
import {type G,K,HT,px,frame,bands,disc} from './hd-kit';
import {panel,label,fan,pipe,window} from './hd-hachi-study';
export const NORTH_STUDY_BUILDINGS=['sleep','flats','bar-row','hotel-tower'] as const;
function rail(g:G,x:number,y:number,w:number){px(g,x,y,w,2,K.metalHi);for(let j=0;j<w;j+=9)px(g,x+j,y,2,13,K.metalLo);px(g,x,y+12,w,3,K.metal);}
export function paintKabukiNorth(g:G,b:HdBuilding,x:number,y:number,L:LightFn){
 if(!(NORTH_STUDY_BUILDINGS as readonly string[]).includes(b.id))return;
 const w=b.w*HT,h=b.h*HT,rh=(b.h-b.face)*HT,fy=y+rh;
 g.save();g.beginPath();g.rect(x,y,w,h);g.clip();pipe(g,x+w-12,y+14,rh-27);
 if(b.id==='hotel-tower'){
  // Narrow tower: vertical glazed floors, retained utility roof, clear HOTEL identity.
  panel(g,x+18,y+119,w-40,57,K.concreteLo);fan(g,x+26,y+129);px(g,x+61,y+137,34,8,K.metalLo);
  window(g,x+27,y+218,w-57,54,K.glassLo);for(let j=1;j<3;j++)px(g,x+29,y+218+j*17,w-61,2,K.metalHi);
  label(g,'HOTEL',x+20,y+282,w-40,K.pink,2);
  bands(g,x+2,fy+2,w-4,h-rh-4,K.wall,K.wallLo,10);
  for(let row=0;row<5;row++)for(let col=0;col<3;col++){const xx=x+12+col*36,yy=fy+10+row*26;window(g,xx,yy,28,20,(row+col)%3===0?K.amber:K.glassLo);px(g,xx+13,yy+2,1,16,K.metalLo);}
  for(const xx of [x+6,x+w-9])px(g,xx,fy+6,3,138,K.metalHi);
  label(g,'HOTEL',x+17,fy+142,w-34,K.pink,2);
  window(g,x+w/2-20,fy+170,40,19,K.amber);px(g,x+w/2,fy+172,1,15,K.metalLo);
  L(x+24,fy+149,w-48,16,K.pink,.21,true);
 }else if(b.id==='flats'){
  panel(g,x+22,y+66,w-48,43,K.woodLo);for(let j=4;j<39;j+=8)px(g,x+26,y+66+j,w-56,1,K.woodHi);
  px(g,x+29,y+59,w-62,1,K.metalHi);for(let j=0;j<6;j++){px(g,x+34+j*29,y+59,2,6,K.woodHi);px(g,x+30+j*29,y+65,17,21,j%2?K.concreteHi:K.woodLo);}
  rail(g,x+25,y+100,w-54);
  bands(g,x+2,fy+2,w-4,h-rh-4,K.concrete,K.wallLo,6);
  for(let j=0;j<4;j++){const xx=x+13+j*59;window(g,xx,fy+7,45,26,j%3?K.amber:K.glassLo);px(g,xx+4,fy+9,7,22,K.woodLo);rail(g,xx-2,fy+29,49);panel(g,xx+9,fy+48,26,11,K.metalLo);px(g,xx+12,fy+51,20,1,K.metalHi);}
 }else if(b.id==='sleep'){
  panel(g,x+25,y+54,90,55,K.concreteLo);fan(g,x+33,y+63);fan(g,x+69,y+63);
  window(g,x+145,y+70,65,35,K.glassLo);px(g,x+176,y+72,2,31,K.metalHi);
  bands(g,x+2,fy+2,w-4,h-rh-4,K.wall,K.wallLo,6);
  label(g,'ホテル',x+76,fy+5,w-152,K.pink,2);
  for(const xx of [x+12,x+w-67])window(g,xx,fy+9,55,23,K.amber);
  for(let j=0;j<5;j++){const xx=x+14+j*47;window(g,xx,fy+37,37,22,j%2?K.glassLo:K.amber);px(g,xx+4,fy+39,5,18,K.woodLo);}
  L(x+82,fy+11,w-164,16,K.pink,.19,true);
 }else{
  panel(g,x+127,y+42,115,67,K.wallLo);window(g,x+137,y+52,44,26,K.glassLo);panel(g,x+193,y+52,35,47,K.metalLo);
  fan(g,x+25,y+72);fan(g,x+63,y+72);px(g,x+95,y+81,31,9,K.metalLo);
  panel(g,x+w-114,y+54,83,55,K.woodLo);disc(g,x+w-73,y+79,17,9,K.woodHi);rail(g,x+w-111,y+98,77);
  bands(g,x+2,fy+2,w-4,h-rh-4,K.woodHi,K.woodLo,6);
  for(let j=0;j<3;j++){const xx=x+j*128;label(g,j===1?'BAR':'バー',xx+27,fy+4,74,K.pink,2);window(g,xx+12,fy+34,31,26,K.amber);window(g,xx+53,fy+34,62,23,K.amber);for(let k=7;k<56;k+=12){px(g,xx+53+k,fy+41,5,12,K.woodLo);px(g,xx+55+k,fy+38,2,4,K.metalHi);}px(g,xx+55,fy+52,58,3,K.woodHi);L(xx+34,fy+10,60,16,K.pink,.17,true);}
 }
 frame(g,x+2,fy+2,w-4,h-rh-4,K.ink);px(g,x+2,y+h-4,w-4,3,K.ink);g.restore();
}
